{ fetchJson } = require '../actions/index'

module.exports =
	teachers: (classroomId) ->
		return (dispatch, getState) ->
			fetchJson "/api/classrooms/#{classroomId}/teachers", null, null, dispatch



// WEBPACK FOOTER //
// ./frontend/olos/js/api/classrooms.coffee